import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5'

import { GlobalStyle } from './style'

export const App: React.FC = ({ children }) => {
  return (
    <>
      <GlobalStyle />
      <QueryClientProvider client={queryClient}>
        <Router basename={process.env.PUBLIC_URL}>
          <QueryParamProvider adapter={ReactRouter5Adapter}>
            {children}
          </QueryParamProvider>
        </Router>
      </QueryClientProvider>
    </>
  )
}

const queryClient = new QueryClient()
